import { useTranslation } from "react-i18next";
import React, { memo, useEffect } from "react";
import { Outlet } from "react-router-dom";

import { LayoutContainer } from "@components/layout/layoutContainer";
import { useAxiosErrorStore } from "@/stores/axiosErrorStore";

export const Root = memo(function Root() {
  const { i18n } = useTranslation();
  const error = useAxiosErrorStore((state) => state.error);

  useEffect(() => {
    document.documentElement.dir = i18n.dir();
    document.documentElement.lang = i18n.language;
  }, [i18n]);

  if (error) {
    // eslint-disable-next-line @typescript-eslint/only-throw-error
    throw new Response(error?.message || "", {
      status: error?.status,
    });
  }

  return (
    <React.StrictMode>
      <Outlet />
      <LayoutContainer />
    </React.StrictMode>
  );
});
